module.exports = __webpack_public_path__ + "static/brett-2b8c3213cfd7e9926060ff122f791406.jpg";